<template>
  <div class="notifications">
    <h2 class="content-subtitle">
      Notifications
      <a href="#" class="underline">View all</a>
    </h2>
    <div class="notification new">
      <div class="time">9:15 AM</div>
      <div class="text">
        <div class="where">Users</div>
        <p>Thibault Denys has just approved a new DHF</p>
      </div>
    </div>
    <div class="notification new">
      <div class="time">9:15 AM</div>
      <div class="text">
        <div class="where">Users</div>
        <p>Thibault Denys has just approved a new DHF</p>
      </div>
    </div>
    <div class="notification">
      <div class="time">9:15 AM</div>
      <div class="text">
        <div class="where">Users</div>
        <p>Thibault Denys has just approved a new DHF</p>
      </div>
    </div>
    <div class="notification">
      <div class="time">9:15 AM</div>
      <div class="text">
        <div class="where">Users</div>
        <p>Thibault Denys has just approved a new DHF</p>
      </div>
    </div>
    <div class="notification">
      <div class="time">9:15 AM</div>
      <div class="text">
        <div class="where">Users</div>
        <p>Thibault Denys has just approved a new DHF</p>
      </div>
    </div>
    <div class="notification">
      <div class="time">9:15 AM</div>
      <div class="text">
        <div class="where">Users</div>
        <p>Thibault Denys has just approved a new DHF</p>
      </div>
    </div>
    <div class="notification">
      <div class="time">9:15 AM</div>
      <div class="text">
        <div class="where">Users</div>
        <p>Thibault Denys has just approved a new DHF</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    style() {
      return "height: " + this.height + "%";
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
    height: String
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";
@import "@/style/components/notifications.scss";

.side_box {
  max-height: 440px;
}
</style>
